import * as React from 'react';

export interface ITypeCropDivider {
  data: any;
  isEditorView: boolean;
}

export default class TypeCropDivider extends React.Component<ITypeCropDivider> {
  constructor(props: ITypeCropDivider) {
    super(props);
  }

  renderDubleLine(nameArr: Array<string>) {
    return <span className="crop-page-crop-divider-name">{nameArr[0]}<br />{nameArr[1]} </span>;
  }

  renderSingleLine(nameArr: Array<string>) {
    return <span className="crop-page-crop-divider-name">{nameArr[0]}</span>;
  }
  render() {
    const { name, img, bg_type } = this.props.data;
    const start = img.substr(0, img.indexOf('Asset'));
    const end = img.substr(img.indexOf('Asset'), img.length);
    let imgSrc = '';
    if (typeof(window) !== 'undefined') {
      imgSrc = `${start}web/${end}`;
    } else {
      imgSrc = `${start}print/${end}`;
    }
    const className = `crop-page-crop-divider ${bg_type}`;
    const nameArr = name.split(' ');
    return (
      <div className={className}>
        <img src={imgSrc} alt="" />
        {
          nameArr[1] ? this.renderDubleLine(nameArr) : this.renderSingleLine(nameArr)
        }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/PageTypes/TypeCropDivider.tsx